// Premiere's standard FCP7 XML label names are the bridge between the paper
// story and the imported timeline. RGB is an approximation: Premiere's
// preferences can customise what each of these names looks like.
export const SOURCE_LABEL_PALETTE=Object.freeze([
  {label:'Iris',colour:'#8f79c9'},
  {label:'Forest',colour:'#47a37d'},
  {label:'Rose',colour:'#d56b89'},
  {label:'Caribbean',colour:'#40abb2'},
  {label:'Mango',colour:'#d6a04a'},
  {label:'Cerulean',colour:'#659edd'},
  {label:'Lavender',colour:'#b78ed5'},
  {label:'Tan',colour:'#ac9870'}
]);

// Preserve the order once assigned. Newly imported sources are appended, never
// sorted into the middle of an existing project colour key.
export function sourceColourOrder(previous=[],interviewIds=[]){
  const output=[],seen=new Set();
  for(const id of [...previous,...interviewIds]){
    if(!id || seen.has(id))continue;
    seen.add(id);output.push(id);
  }
  return output;
}

export function sourcePaletteEntry(id,orderedIds=[]){
  const position=orderedIds.indexOf(id);
  if(position>=0)return SOURCE_LABEL_PALETTE[position%SOURCE_LABEL_PALETTE.length];
  // Legacy callers can still render a colour before project rows load.
  let hash=2166136261;
  for(const char of String(id||'interview'))hash=Math.imul(hash^char.charCodeAt(0),16777619)>>>0;
  return SOURCE_LABEL_PALETTE[hash%SOURCE_LABEL_PALETTE.length];
}
export const sourcePremiereLabel=(id,orderedIds=[])=>sourcePaletteEntry(id,orderedIds).label;
export function interviewColour(id,orderedIds=[]) {
  const {colour,label}=sourcePaletteEntry(id,orderedIds);
  return {'--source-colour':colour,'--source-tint':`color-mix(in srgb, ${colour} 23%, white)`,
    '--source-tint-dark':`color-mix(in srgb, ${colour} 31%, #282f2a)`,
    '--source-label-name':`"${label}"`};
}

export function passageWords(words,passage) {
  return words.filter(word=>word.start<passage.end && word.end>passage.start);
}

export function storyWordIds(words,blocks,sourceId) {
  const ranges=blocks.filter(block=>block.sourceId===sourceId);
  return words.filter(word=>ranges.some(range=>word.start<range.end && word.end>range.start)).map(word=>word.id);
}
